import { Button, InputSearch } from 'uikit'
import { useEffect, useRef, useState } from 'react'

export const ListFilter = ({ initialState, onChange }) => {
  const [state, setState] = useState(initialState)
  const prevState = useRef(state)

  useEffect(() => {
    if (state !== prevState.current) {
      onChange(state)
      prevState.current = state
    }
  }, [state])

  const handleFilter = (value) => {
    setState((state) => ({ ...state, ...value }))
  }

  const handleResetFilter = () => {
    setState({})
  }

  return (
    <>
      <InputSearch
        hideIcon
        label="Группа"
        value={state.group}
        onChange={(value) => handleFilter({ group: value })}
      />
      <Button size="sm" width="full" onClick={handleResetFilter}>
        Очистить фильтр
      </Button>
    </>
  )
}
